import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { DBItem } from 'types/dynamicDB';

type InitialdbManaginState = {
    selectedDatabase: DBItem | null;
}

const initialState: InitialdbManaginState = {
    selectedDatabase: null,
}

export const dbManagSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setSelectedDatabase: (state, action: PayloadAction<DBItem | null>) => {
            state.selectedDatabase = action.payload
        }
    },
})

export const { setSelectedDatabase } = dbManagSlice.actions

export default dbManagSlice.reducer

